const DIGITAL_TRANSFER_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: '',
        textMob: '',
        secondText: 'All Types of Discs',
        secondTextMob: 'All Types of',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: true,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: true,
        firstTextLines: [],
        secondTextLines: [{
          id: 1,
          isLeftLine: false,
          isRightLine: true,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: true,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#fff',
          isLineWithSquareMob: true,
        }],
      },
      {
        id: 2,
        text: 'Converted to Digital.',
        textMob: 'Discs.',
        secondText: '',
        secondTextMob: '',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: false,
        isLeftMob: true,
        isRight: true,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: true,
        isTextWithLineMob: false,
        isSecondTextWithLine: false,
        isSecondTextWithLineMob: false,
        firstTextLines: [{
          id: 1,
          isLeftLine: true,
          isRightLine: false,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: false,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#5F8AA4',
          isLineWithSquareMob: true,
        }],
        secondTextLines: [],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'VIDEO DVDs',
      description: 'Transfer your home video DVDs to modern digital formats for easy viewing.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 2,
      title: 'CDs',
      description: 'Convert your audio and photo CDs to high-quality digital files.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 3,
      title: 'Data Discs',
      description: 'Recover and archive data from old data CDs and DVDs with professional care.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 4,
      title: 'Camcorder DVD',
      description: 'Transfer mini DVD camcorder discs to full-resolution digital video.',
      image: '',
      imageMob: '',
      link: '',
    },
  ],
};

export default DIGITAL_TRANSFER_TYPES_LIST_DATA;
